var _path, _path2, _rect, _rect2, _rect3, _rect4, _circle;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 45,
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5731 19.5567H5.98389V39.1135C5.98389 42.3377 8.59758 44.9513 11.8217 44.9513H30.6488V36.7784H13.5731V19.5567Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5132 15.7622H34.5889V44.9513H42.6159V15.7622H53.9997V7.88107H17.5132V15.7622Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5459,
    y: 7.88107,
    width: 8.46486,
    height: 8.46486,
    fill: "#774CF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75146,
    y: 6.71352,
    width: 2.91892,
    height: 2.91892,
    fill: "#774CF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.12939,
    y: 3.79459,
    width: 2.91892,
    height: 2.91892,
    fill: "#774CF3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75146,
    y: 2.62703,
    width: 2.33514,
    height: 2.33514,
    fill: "#774CF3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.875676,
    cy: 0.875676,
    r: 0.875676,
    fill: "#774CF3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/newLogo.0068c742882b7ebc852549cb9b2b1372.svg";
export { ForwardRef as ReactComponent };